import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';

// Generic task state type
export type TaskState = 'WAITING' | 'PROCESSING' | 'COMPLETED' | 'ERROR' | 'PARTIAL_SUCCESS' | 'CANCELLED' | 'PENDING' | 'SUCCESS' | '%future added value';

export type ResultStatus = 'ERROR' | 'PARTIAL' | 'SKIPPED' | 'SUCCESS';

interface TaskStatusBadgeProps {
    status: TaskState | ResultStatus;
    className?: string;
}

const StyledBadge = styled.span<{ $status: TaskState | ResultStatus }>`
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;

    ${(props) => {
        const status = props.$status;
        switch (status) {
            case 'WAITING':
            case 'PENDING':
                return `
					background-color: #f3f4f6;
					color: #374151;
				`;
            case 'PROCESSING':
                return `
					background-color: #dbeafe;
					color: #1e40af;
				`;
            case 'COMPLETED':
            case 'SUCCESS':
                return `
					background-color: #d6f3e2;
					color: #065f46;
				`;
            case 'ERROR':
                return `
					background-color: #fee2e2;
					color: #991b1b;
				`;
            case 'PARTIAL_SUCCESS':
            case 'PARTIAL':
                return `
					background-color: #fef3c7;
					color: #92400e;
				`;
            case 'CANCELLED':
            case 'SKIPPED':
                return `
					background-color: #f3f4f6;
					color: #374151;
				`;
            default:
                return `
					background-color: #f3f4f6;
					color: #374151;
				`;
        }
    }}
`;

export const getStatusLabel = (status: TaskState | ResultStatus): string => {
    switch (status) {
        case 'PENDING':
        case 'WAITING':
            return T._('In progress', 'Admin');
        case 'PROCESSING':
            return T._('Processing', 'Admin');
        case 'COMPLETED':
        case 'SUCCESS':
            return T._('Completed', 'Admin');
        case 'ERROR':
            return T._('Failed', 'Admin');
        case 'PARTIAL':
        case 'PARTIAL_SUCCESS':
            return T._('Partial Success', 'Admin');
        case 'CANCELLED':
            return T._('Cancelled', 'Admin');
        case 'SKIPPED':
            return T._('Skipped', 'Admin');
        default:
            return T._('Unknown', 'Admin');
    }
};

/**
 * TaskStatusBadge - Atomic component for displaying task status
 * Can be used for any type of task (template duplication, sales channel switching, etc.)
 */
export const TaskStatusBadge: React.FC<TaskStatusBadgeProps> = ({ status, className }) => {
    return (
        <StyledBadge $status={status} className={className}>
            {getStatusLabel(status)}
        </StyledBadge>
    );
};

export default TaskStatusBadge;
